import Vue from 'vue'
import Vuex from '@picnic-software/vuex'
import createPersistedState from 'vuex-persistedstate'
import persistOptions from './persist-options'

// Fresh
import app from '@/store/modules/app'
import auth from '@/store/modules/auth'
import account from '@/store/modules/account'
import site from '@/store/modules/site'
import pages from '@/store/modules/pages'
import provider from '@/store/modules/provider'
import router from '@/store/modules/router'
import dots from '@/store/modules/dots'
import browser from '@/store/modules/browser'
import toasts from '@/store/modules/toasts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    app,
    auth,
    account,
    provider,
    site,
    router,
    pages,
    dots,
    browser,
    toasts
  },
  // plugins: [createPersistedState(persistOptions)],
  strict: debug
})
